// Services Img Imports
import Web from "../assets/images/Services/Web.png";
import Mobile from "../assets/images/Services/Mobile.png";
import UIUX from "../assets/images/Services/Design.png";

// Portfolio Img Imports
import landscape1 from "../assets/images/Portfolio/landscape21.png";
import landscape2 from "../assets/images/Portfolio/landscape22.png";
import landscape3 from "../assets/images/Portfolio/landscape23.png";
import landscape4 from "../assets/images/Portfolio/landscape24.png";
import landscape5 from "../assets/images/Portfolio/landscape25.png";
import landscape6 from "../assets/images/Portfolio/landscape26.png";

// Advantages
import Communicative from "../assets/images/Advantages/communicatin.png";
import Collaborative from "../assets/images/Advantages/Collaborative.png";
import Management from "../assets/images/Advantages/Management.png";
import Favorite from "../assets/images/Advantages/Favorite.png";

// Testimonials
import Abebe from "../assets/images/Testimonials/3.jpg";
import Dawit from "../assets/images/Testimonials/2.jpg";
import Aster from "../assets/images/Testimonials/1.jpg";

// TeamMembers
import CEO from "../assets/images/TeamMembers/CEO.jpg";
import HRD from "../assets/images/TeamMembers/HRD.jpg";
import Finance from "../assets/images/TeamMembers/Finance.jpg";
import ProjectManager from "../assets/images/TeamMembers/Project-manager.jpg";
import Frontend1 from "../assets/images/TeamMembers/Frontend1.jpg";
import Frontend2 from "../assets/images/TeamMembers/Frontend2.jpg";
import Backend1 from "../assets/images/TeamMembers/Backend1.jpg";
import Backend2 from "../assets/images/TeamMembers/Backend2.jpg";
import Mobile1 from "../assets/images/TeamMembers/Mobile1.jpg";
import Mobile2 from "../assets/images/TeamMembers/Mobile2.jpg";
import UIUX1 from "../assets/images/TeamMembers/UIUX1.jpg";
import UIUX2 from "../assets/images/TeamMembers/UIUX2.jpg";

export const Services = [
  {
    title: "AT Landscape",
    imageUrl: Web,
    animation: "right",
    link: "/",
  },
  {
    title: "Ago-Mart supermarket",
    imageUrl: Mobile,
    animation: "right",
    link: "/LandingPage1",
  },
  {
    title: "Marine Logistics",
    imageUrl: UIUX,
    animation: "/right",
    link: "/LandingPage2",
  },
];

export const Portfolios = [
  {
    id: "asd1293uasdads1",
    title: "Low bed",
    imageUrl: landscape1,
  },
  {
    id: "asd1293uhjkhkjh2",
    title: "Ocean Freight core services",
    imageUrl: landscape2,
  },
  {
    id: "asd1293uvbvcbbd3",
    title: "Air Freight core services",
    imageUrl: landscape3,
  },
  {
    id: "asd1293ufgdfgs4",
    title: "Land transport",
    imageUrl: landscape4,
  },
  {
    id: "asd1293ulskmnb5",
    title: "Heavy lifting",
    imageUrl: landscape5,
  },
  {
    id: "asd1293ulkmnbj6",
    title: "Warehousing,packing and moving",
    imageUrl: landscape6,
  },
];

export const Advantages = [
  [
    {
      title: "Communicative",
      description:
        "We communicate with our team and progress to make it clear.",
      imageUrl: Communicative,
    },
    {
      title: "Management",
      description:
        "We manage our company properly to make our product qualified.",
      imageUrl: Management,
    },
  ],
  [
    {
      title: "Collaborative​",
      description:
        "Our team are very collaborative to make our product qualified.",
      imageUrl: Collaborative,
    },
    {
      title: "Favorite",
      description: "We've so many products and all of our client love it.",
      imageUrl: Favorite,
    },
  ],
];
export const Testimonials = [
  {
    id: 1,
    name: "Abebe Bekele",
    testimoni:
      "Thanks for Ago-Mart supermarket, you guys are the best! Keep up the great work!",
    imageUrl: Abebe,
  },
  {
    id: 2,
    name: "Aster Tadesse",
    testimoni:
      "I just wanted to let you know that it’s been great working with Marine Logistics.",
    imageUrl: Aster,
  },
  {
    id: 3,
    name: "Dawit Yohannes",
    testimoni:
      "AT landscape is so great. Thank you so much for a job well done.",
    imageUrl: Dawit,
  },
];

export const TeamMembers = [
  {
    name: "Michael Scott",
    position: "Fleet Manage",
    imageUrl: CEO,
  },
  {
    name: "Pam Beesly",
    position: "Logistics Engineer",
    imageUrl: HRD,
  },
  {
    name: "Oscar Martinez",
    position: "Finance",
    imageUrl: Finance,
  },
  {
    name: "Jim Halpert",
    position: "Logistics Support Staff",
    imageUrl: ProjectManager,
  },
  {
    name: "Kevin Malone",
    position: "Accountant",
    imageUrl: Frontend1,
  },
  {
    name: "Dwight Schrute",
    position: "Quality Control Inspector",
    imageUrl: Frontend2,
  },
  {
    name: "Stanley Hudson",
    position: "Materials Manager",
    imageUrl: Backend1,
  },
  {
    name: "Ryan Howard",
    position: "Logistics Marketing Specialist",
    imageUrl: Backend2,
  },
  {
    name: "Darryl Philbin",
    position: "Transportation Analyst",
    imageUrl: Mobile1,
  },
  {
    name: "Andy Bernard",
    position: "Packaging Coordinator",
    imageUrl: Mobile2,
  },
  {
    name: "Angela Martin",
    position: "Distribution Manager",
    imageUrl: UIUX2,
  },
  {
    name: "Kelly Kapoor",
    position: "Delivery Driver",
    imageUrl: UIUX1,
  },
];
